import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AttachmentList } from "../attachment/attachmentList";
import { AttachmentSummaryList } from "../attachment/attachmentSummaryList";
import { IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { FormRow } from "../framework/formRow";

//EventEditActionsSummary
interface IEventEditActionsSummaryProp {
    immediateAction: string;
    preventiveAction: string;
    rootCause: string;
    lateThreshold: number;
    attachments: IFileAttachment[];
    onDownloadAttachment: (id: string) => void;
    attachmentsAreEditable: boolean;
    canShowCamera: boolean;
    onRemoveAttachment: (id: string) => void;
    onAddAttachments: (fileList: FileList) => void;
    onAddPhoto: () => void;
}

export class EventEditActionsSummary extends React.Component<IEventEditActionsSummaryProp, {}> {
    render() {
        const props = this.props;
        return (
            <div className="summarySection">
                <FormRow
                    label={Translations.ImmediateAction}
                >
                    <div className="preWrap">{props.immediateAction}</div>
                </FormRow>
                <FormRow
                    label={Translations.PreventiveAction}
                >
                    <div className="preWrap">{props.preventiveAction}</div>
                </FormRow>
                <FormRow
                    label={Translations.RootCause}
                >
                    <div className="preWrap">{props.rootCause}</div>
                </FormRow>
                {props.attachments.length > 0 &&
                    <FormRow
                        label={Translations.Attachments}
                    >
                        {props.attachmentsAreEditable &&
                            <AttachmentList
                                isReadOnly={false}
                                canShowCamera={props.canShowCamera}
                                lateThreshold={props.lateThreshold}
                                attachments={props.attachments}
                                onDownloadAttachment={props.onDownloadAttachment}
                                onRemoveAttachment={props.onRemoveAttachment}
                                onAddAttachments={props.onAddAttachments}
                                onAddPhoto={props.onAddPhoto}
                            />
                        }
                        {!props.attachmentsAreEditable &&
                            <AttachmentSummaryList
                                lateThreshold={props.lateThreshold}
                                attachments={props.attachments}
                                onDownloadAttachment={props.onDownloadAttachment}
                            />
                        }
                    </FormRow>
                }
            </div>
        );
    }
}
